import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { faqs } from "../../data/content";
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-white px-4 py-16 sm:py-24" data-id="element-173" data-mp="2z2p6yys9pdtb">
      <div className="mx-auto max-w-3xl" data-id="element-174" data-mp="2z5bdcv3f9n9y">
        <h2 className="text-balance text-center font-serif text-3xl font-bold leading-tight text-ink sm:text-5xl" data-id="element-175" data-mp="3ms9t1qjpwr6t">
          Frequently asked <em className="text-gold" data-id="element-176" data-mp="3rrcwj6k1upco">questions</em>
        </h2>

        <ul className="mt-10 space-y-3" data-id="element-177" data-mp="3d3jj9sifryx9">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.q} className="overflow-hidden rounded-2xl bg-cream" data-id="element-178" data-mp="3i0ibg5ijhvst" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-gold" data-id="element-179" data-mp="9l8aj0qdywmm">
                  <span className="text-[16px] font-bold leading-snug text-ink" data-id="element-180" data-mp="1vpspox8fv4o3">{f.q}</span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold transition-transform duration-200 ease-out ${isOpen ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-181" data-mp="2aimjlnogjnca" />
                </button>
                <AnimatePresence initial={false} data-id="element-182" data-mp="2eiwqd2k2qhs7">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-183" data-mp="2tfxhb3ufy8pm">
                      <div className="space-y-2 px-5 pb-5 text-[15px] leading-relaxed text-ink/75" data-id="element-184" data-mp="u31rgtqrsquc">
                        {f.a.map(p => <p key={p} data-id="element-185" data-mp="1jsi9lnqmb8xn">{p}</p>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>

        <div className="mt-10" data-id="element-186" data-mp="1xpx06vslxmr7">
          <CTAButton label="Yes, I'm ready to start today" data-id="element-187" data-mp="1xqzttbhbe3at" />
        </div>
      </div>
    </section>;
}